import { codeBlock } from '@lumapps/lumx/custom-icons';
import { useTextualBlockToggleButton } from '@lumapps/wrex-textual-block/components/buttons/useTextualBlockToggleButton';
import { TypographyEditor } from '@lumapps/wrex-typography/types';

import { CODE_BLOCK } from '../../../constants';
import { WREX_CODE_BLOCK } from '../../../keys';
import { CodeBlockEditor } from '../../../types';

interface UseCodeBlockButtonOptions {
    /** Data-attributes scope used to build the button's `data-*` props. */
    scope: string;
    /** Whether the editor is read-only — disables the button. */
    isReadOnly?: boolean;
}

export const useCodeBlockButton = ({ scope, isReadOnly }: UseCodeBlockButtonOptions) =>
    useTextualBlockToggleButton<CodeBlockEditor & TypographyEditor>({
        type: CODE_BLOCK,
        icon: codeBlock,
        label: WREX_CODE_BLOCK.BUTTON_LABEL,
        isAllowed: (editor) => editor.isCodeBlockAllowed(),
        scope,
        isReadOnly,
    });
